'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002413 from "./presto.-Agent-View$$anon$13.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024 from "./presto.-Agent-View$-Upload-File-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$12() {
  this.avM = null;
  this.avE = null;
  this.avF = false;
  this.avN = null;
  this.avO = false;
  this.avR = null;
  this.avK = null;
  this.avL = false;
  this.avG = null;
  this.avH = false;
  this.avI = null;
  this.avJ = false;
  this.avP = false;
  this.avQ = false;
  this.avM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.avR = "UploadFileRequest";
}
export { $c_Lpresto_AgentView$$anon$12 as $c_Lpresto_AgentView$$anon$12 };
$p = $c_Lpresto_AgentView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$12;
/** @constructor */
function $h_Lpresto_AgentView$$anon$12() {
}
export { $h_Lpresto_AgentView$$anon$12 as $h_Lpresto_AgentView$$anon$12 };
$h_Lpresto_AgentView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.avM;
});
$p.M = (function() {
  if ((!this.avF)) {
    this.avE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avF = true;
  }
  return this.avE;
});
$p.O = (function() {
  if ((!this.avO)) {
    this.avN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.avO = true;
  }
  return this.avN;
});
$p.E = (function() {
  return this.avR;
});
$p.t = (function() {
  if ((!this.avL)) {
    this.avK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("text", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.avL = true;
  }
  return this.avK;
});
$p.N = (function() {
  if ((!this.avH)) {
    this.avG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.avH = true;
  }
  return this.avG;
});
$p.Q = (function() {
  if ((!this.avJ)) {
    this.avI = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002413.$c_Lpresto_AgentView$$anon$13();
    this.avJ = true;
  }
  return this.avI;
});
$p.v = (function() {
  if ((!this.avQ)) {
    this.avP = false;
    this.avQ = true;
  }
  return this.avP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee84) => ((p) => \u03b4scrutinee84.cFo(p)))($j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024.$m_Lpresto_AgentView$UploadFileRequest$())));
});
var $d_Lpresto_AgentView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$12, "presto.AgentView$$anon$12", ({
  Dy: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$12 as $d_Lpresto_AgentView$$anon$12 };
//# sourceMappingURL=presto.-Agent-View$$anon$12.js.map
